import {CHANGE_ROLE,ISBLOCKING,PATH_NAME} from '../role/actions';

export const roleReducer = (previousState = false, { type, payload }) => {
    if (type === CHANGE_ROLE) {
        return payload;
    }
    return previousState;
};

export const isBlockingReducer = (previousState = false, { type, payload }) => {
    if (type === ISBLOCKING) {
        return payload;
    }
    return previousState;
};

export const pathNameReducer = (previousState = '/roles', { type, payload }) => {
    if (type === PATH_NAME) {
        return payload;
    }
    return previousState;
};
